/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaIconMonitorHeart/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TysiaIconMonitorHeart({
  children,
  viewPath = "/DesignSystem/Svgs/TysiaIconMonitorHeart",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 24,
  height = 24,
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill = "#323232"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="TysiaIconMonitorHeart.Svg"
  data-view-path={viewPath}
 viewBox="0 0 24 24"
 style={{'--as-1-BFj4a': alignSelf,'--mt-2-BFj4a': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-BFj4a': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-BFj4a': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-BFj4a': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-BFj4a': opacity,'--w-10-BFj4a': typeof width === 'number' ? `${width}px` : width,'--h-11-BFj4a': typeof height === 'number' ? `${height}px` : height,'--a-7-BFj4a': isAnimated ? animation : "none",'--sd-8-BFj4a': isAnimated ? strokeDashoffset : 0,'--sd-9-BFj4a': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="TysiaIconMonitorHeart.SvgPath"
  data-view-path={viewPath}
 d="M20 4H4c-1.1 0-2 .9-2 2v3h2V6h16v3h2V6c0-1.1-.9-2-2-2zm0 14H4v-3H2v3c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2v-3h-2v3z"
 style={{'--f-12-BFj4a': fill}}
 className={`views-block ${styles.SvgPath}`}
/>
<path
  data-testid="TysiaIconMonitorHeart.SvgPath:1"
  data-view-path={viewPath}
 d="M14.89 7.55c-.34-.68-1.45-.68-1.79 0L10 13.76l-1.11-2.21A.988.988 0 008 11H2v2h5.38l1.72 3.45c.18.34.52.55.9.55s.72-.21.89-.55L14 10.24l1.11 2.21c.17.34.51.55.89.55h6v-2h-5.38l-1.73-3.45z"
 style={{'--f-12-BFj4a': fill}}
 className={`views-block ${styles.SvgPath1}`}
/>
</svg>
{children}
</React.Fragment>)
}